module.exports = __webpack_public_path__ + "static/media/Ai Robot Vector Art.60dcb29e.gif";